/**Packages */
import { Oval } from "react-loader-spinner";

/**SCSS */
import "./_loader.scss";

const ReactLoader = ({ visible = false }) => {
    return visible ? (
        <div className="loader-container">
            <Oval
                //type="Oval"
                color="#00BFFF"
                visible={true}
                height={100}
                width={100} //3 secs
            />
        </div>
    ) : null;
};

export default ReactLoader;
